import isAgentBargedIn from '../isAgentBargedIn';
import isAgentMonitoring from '../isAgentMonitoring';

export default function isAgentSupervising(contact: connect.Contact): boolean {
  const isMonitoring = isAgentMonitoring(contact);
  const isBargedIn = isAgentBargedIn(contact);

  return isMonitoring || isBargedIn;
}
